var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CodeInput',{ref:"field",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"class-name":"fs-exclude otp-field primary--text text--darken-1","field-width":48,"field-height":48,"auto-focus":true},on:{"complete":function($event){return _vm.$emit('complete', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }